import { render, staticRenderFns } from "./PatientVisit.vue?vue&type=template&id=fc9f0ab0&scoped=true"
import script from "./PatientVisit.vue?vue&type=script&lang=js"
export * from "./PatientVisit.vue?vue&type=script&lang=js"
import style0 from "./PatientVisit.vue?vue&type=style&index=0&id=fc9f0ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9f0ab0",
  null
  
)

export default component.exports